import { styled } from "src/styles/theme";

export const Cluster = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  gap: "var(--space, $4)",
  alignItems: "center",

  variants: {
    justify: {
      start: {
        justifyContent: "flex-start",
      },
      center: {
        justifyContent: "center",
      },
      end: {
        justifyContent: "flex-end",
      },
    },
    size: {
      small: {
        gap: "$2",
      },
      normal: {
        gap: "$4",
      },
      medium: {
        gap: "$6",
      },
      large: {
        gap: "$12",
      },
    },
  },
});

Cluster.defaultProps = {
  justify: "start",
};
